var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiCamera1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.83073 2.83464H4.95573L6.3724 1.41797H10.6224L12.0391 2.83464H14.1641C14.5398 2.83464 14.9001 2.98389 15.1658 3.24957C15.4315 3.51524 15.5807 3.87558 15.5807 4.2513V12.7513C15.5807 13.127 15.4315 13.4874 15.1658 13.753C14.9001 14.0187 14.5398 14.168 14.1641 14.168H2.83073C2.45501 14.168 2.09467 14.0187 1.82899 13.753C1.56332 13.4874 1.41406 13.127 1.41406 12.7513V4.2513C1.41406 3.87558 1.56332 3.51524 1.82899 3.24957C2.09467 2.98389 2.45501 2.83464 2.83073 2.83464ZM8.4974 4.95964C7.55809 4.95964 6.65725 5.33277 5.99306 5.99697C5.32887 6.66116 4.95573 7.56199 4.95573 8.5013C4.95573 9.44061 5.32887 10.3414 5.99306 11.0056C6.65725 11.6698 7.55809 12.043 8.4974 12.043C9.4367 12.043 10.3375 11.6698 11.0017 11.0056C11.6659 10.3414 12.0391 9.44061 12.0391 8.5013C12.0391 7.56199 11.6659 6.66116 11.0017 5.99697C10.3375 5.33277 9.4367 4.95964 8.4974 4.95964ZM8.4974 6.3763C9.06098 6.3763 9.60148 6.60018 10 6.9987C10.3985 7.39721 10.6224 7.93772 10.6224 8.5013C10.6224 9.06489 10.3985 9.60539 10 10.0039C9.60148 10.4024 9.06098 10.6263 8.4974 10.6263C7.93381 10.6263 7.39331 10.4024 6.99479 10.0039C6.59628 9.60539 6.3724 9.06489 6.3724 8.5013C6.3724 7.93772 6.59628 7.39721 6.99479 6.9987C7.39331 6.60018 7.93381 6.3763 8.4974 6.3763Z",
    fill: "#E1E1E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCamera1);
export default __webpack_public_path__ + "static/media/mdi_camera1.3dc49c188b6f62b8eac01cb21017546f.svg";
export { ForwardRef as ReactComponent };